if (!customElements.get("blur-banner-athora")) {

  class BlurBannerAthora extends HTMLElement {

    constructor() {
      super();

      this.section = this.closest(".athora-blur-banner");
      this.overlay = this.querySelector(".abb-overlay");
      this.media =
        this.querySelector(".abb-image") ||
        this.querySelector(".abb-video");
      this.hero = this.querySelector(".abb-content-inner");
      this.bottom = this.querySelector(".abb-bottom");

      this.ticking = false;
      this.windowHeight = window.innerHeight;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.update();

      window.addEventListener("scroll", this.onScroll, {
        passive: true
      });

      window.addEventListener("resize", this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScroll);
      window.removeEventListener("resize", this.onResize);
    }

    onResize() {
      this.windowHeight = window.innerHeight;
      this.update();
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;

      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {

      if (!this.section) return;

      const rect = this.section.getBoundingClientRect();

      const total = Math.max(rect.height - this.windowHeight, 1);

      let progress = (-rect.top) / total;

      progress = Math.max(0, Math.min(progress, 1));

      /* Active */

      if (progress >= 0.03) {
        this.section.classList.add("is-active");
      } else {
        this.section.classList.remove("is-active");
      }

      /* Overlay Blur */

      if (this.overlay) {

        const blur = Math.min(progress * 24, 20);

        const opacity = Math.min(0.10 + progress * 0.45, 0.55);

        this.overlay.style.backdropFilter = `blur(${blur}px)`;

        this.overlay.style.webkitBackdropFilter = `blur(${blur}px)`;

        this.overlay.style.background = `rgba(0,0,0,${opacity})`;

      }

      /* Background Zoom */

      if (this.media) {

        const scale = 1 + progress * 0.05;

        this.media.style.transform = `scale(${scale})`;

      }

      /* Hero Move */

      if (this.hero) {

        const move = Math.min(progress * 130, 130);

        this.hero.style.transform = `translate3d(0,-${move}px,0)`;

        this.hero.style.opacity = Math.max(1 - progress * 0.15, 0.85);

      }

      /* Bottom Reveal */

      if (this.bottom) {

        let reveal = (progress - 0.06) / 0.14;

        reveal = Math.max(0, Math.min(reveal, 1));

        this.bottom.style.opacity = reveal;

        this.bottom.style.transform =
          `translate3d(0,${40 - reveal * 40}px,0)`;

      }

    }

  }

  customElements.define("blur-banner-athora", BlurBannerAthora);

}